import { IManagementUnitResponse } from "../../../model/base/response/management-unit-response";


export type ManagedUnitState = {
  managedUnit: IManagementUnitResponse[];
};

export enum ACTION_TYPES {
  loadingData = 'loadingData'
}

export const ManagedUnitReducer = (state: ManagedUnitState, action: any): ManagedUnitState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.loadingData:
      return {
        ...state,
        managedUnit: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}